import { ExternalLink } from 'lucide-react';
import { fileOf, type PinRendererProps } from './pinMediaRenderer';
import { withScheme } from './pinMediaUrl';

export function ProviderFilePin({ pin }: PinRendererProps) {
  const file = fileOf(pin);
  const extension = file?.mime_type?.split('.').pop();
  const label = [file?.type, extension].filter(Boolean).join(' ');
  return (
    <a
      href={withScheme(file?.url ?? pin.url)}
      target="_blank"
      rel="noopener noreferrer"
      className="flex w-56 max-w-full flex-col items-center gap-3 rounded-xl bg-bg-subtle p-8 text-center hover:bg-bg-inset"
    >
      <span className="text-sm font-semibold uppercase text-fg-muted">
        {label}
      </span>
      <ExternalLink className="size-4 text-fg-muted" aria-hidden />
    </a>
  );
}
